import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import DataTableRepository from '../Repositories/DataTableRepository'


class DataTableBloc {

    rowtableChannel = new Subject();
    syncDataChannel = new Subject();
    repository = new DataTableRepository()

    constructor() {
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.syncDataChannel.next({status: apiResponse.INITIAL})
    }

    fetchRowTable = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("unsubscribe")}
    }

    fetchSyncData = async (query, cancelToken) => {
        try {
            this.syncDataChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchSyncData(query, cancelToken).then((result) => {
                this.syncDataChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.syncDataChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("unsubscribe")}
    }
}

export default DataTableBloc